module.exports = {
    bindings: {
        conclusion: '<'
    },
    templateUrl: 'texts/components/ccc-conclusion.html'
};